import {combineReducers} from "@reduxjs/toolkit";
import publicAuthReducer from "./publicAuthSlice";

const publicReducers = () => combineReducers({
  auth: publicAuthReducer
});

export default publicReducers;
